'use client'

import { AIModeToggleHome } from '@/src/components/common/home/AISearch/AIModeToggleHome'
import { FlightContainer } from '@/src/components/common/home/flightSearch/flightContainer'
import SearchForm from '@/src/components/common/home/flightSearch/searchForm'
import { useAIFeatureEnableManager } from '@/src/hooks/AIFeatureEnableManager'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { useIsHeya } from '@/src/hooks/useThemeKey'
import { Box } from '@mui/material'
import { useState } from 'react'

interface MobileSearchWithModeProps {
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
    fromParam?: any[] | null
    toParam?: any[] | null
    initialAiEnabled?: boolean
}

const MobileSearchWithMode: React.FC<MobileSearchWithModeProps> = ({
    serverRecentSearches,
    hideMulticity,
    fromParam,
    toParam,
    initialAiEnabled
}) => {
    const { homeAISearch } = useAIFeatureEnableManager(initialAiEnabled)
    const [mobileMode, setMobileMode] = useState<'search' | 'ai'>('search')
    const isHeya = useIsHeya()

    return (
        <>
            {homeAISearch && (
                <Box display={"flex"} justifyContent={"center"} px={2} pb={1}>
                    <AIModeToggleHome value={mobileMode} onChange={setMobileMode} deviceType="mobile" />
                </Box>
            )}
            <FlightContainer isHeya={isHeya}>
                <SearchForm
                    isMobile={true}
                    serverRecentSearches={serverRecentSearches}
                    hideMulticity={hideMulticity}
                    fromParam={fromParam}
                    toParam={toParam}
                    mobileMode={mobileMode}
                />
            </FlightContainer>
        </>
    )
}

export default MobileSearchWithMode
